import { Reducer } from "redux";
import produce from "immer";
import * as actions from "./memberCardPoolActions";
import { MemberCardPool } from "../../service/api-response/MemberCardPoolsSuccessResponse";

export interface MemberCardPoolState {
  partnerships: {
    [orgKeyName: string]: undefined | MemberCardPool[];
  };
  isLoading: {
    [orgKeyName: string]: undefined | boolean;
  };
}

const initialState: MemberCardPoolState = {
  partnerships: {},
  isLoading: {},
};

type SupportedActions =
  | actions.GetMemberCardPoolsAction
  | actions.GetMemberCardPoolsFailAction
  | actions.GetMemberCardPoolsSuccessAction;

export const memberCardPoolReducer: Reducer<
  MemberCardPoolState,
  SupportedActions
> = (state = initialState, action) => {
  return produce(state, (draftState) => {
    switch (action.type) {
      case actions.GET_MEMBER_CARD_POOLS: {
        draftState.isLoading[action.organization] = true;
        break;
      }
      case actions.GET_MEMBER_CARD_POOLS_FAIL: {
        draftState.isLoading[action.organization] = false;
        break;
      }
      case actions.GET_MEMBER_CARD_POOLS_SUCCESS: {
        draftState.isLoading[action.organization] = false;
        draftState.partnerships[action.organization] = action.memberCardPools;
        break;
      }
      default: {
        return;
      }
    }
  });
};
